import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, SearchManagementAssociationsUsersAction} from '../action';

function* execute({payload: {associationId, searchText}}: SearchManagementAssociationsUsersAction): SagaIterator {
    yield* put(adminAction.setLoading('getUsers', true));
    const response = yield* call(Api.searchAssociationEmployees, {text: searchText}, {associationId});

    if (response.isSuccess) {
        yield* put(adminAction.setManagementAssociationsUsers(response.data));
    } else {
        yield putAll(showBeError(response, t('admin')('subjectsLoading')));
    }
    yield* put(adminAction.setLoading('getUsers', false));
}

/** Runs the admin saga that searches users for the association-management form. */
export function* searchManagementAssociationsUsersSaga(): SagaIterator {
    yield takeLatestF('admin/SEARCH_MANAGEMENT_ASSOCIATIONS_USERS', execute);
}
